export enum MatchSetState {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  PARTIAL = "PARTIAL",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
}

export enum MatchKeyType {
  ROYALTY = "royalty",
  REVENUE = "revenue",
  DEFERRAL = "deferral",
}
